import dynamic from 'next/dynamic';

type dataSrcType = {
  name: string;
  value: number;
};

export interface PieChartComponentProps {
  dataSrc: dataSrcType[];
  currentBalance: string;
  lastUpdate: string;
  btnLabel?: string;
  btnLink?: string;
  doubleColumnLegend?: boolean;
  hideChart?: boolean;
  hasTooltip?: boolean;
  verticaliChart?: boolean;
  colorSchema?: string;
  hasSpendableOnLabel?: boolean;
  labelSaldoCorrente?: string;
  colorLabelSaldoCorrente?: string;
}

export const PieChartComponent = dynamic<PieChartComponentProps>(
  () => import('components/pieChartComponent/PieChartComponent').then((mod) => mod.PieChartComponent),
  { ssr: false }
);
